import { ChatHandlePane } from "./ChatHandlePane";
import styles from "./ChatAssistantNode.module.scss";
import { StreamText, StreamTextFunction } from "@uiview/views/StreamText";
import { useSize } from "ahooks";
import { useRef } from "react";
import { ChatType } from "./ChatInterfaceBloc";
import { isEmpty } from "lodash";

export interface Props {
  showMask: boolean;
  isLast: boolean;
  isError: boolean;
  disabledStream: boolean;
  message: string;
  isStreamStopped?: boolean;
  onRegenerateClicked: () => void;
  onStreamingContentChanged?: () => void;
  onStreamingContentStopped?: (value?: ChatType) => void;
}

export function ChatAssistantNode(props: Props) {
  const containerRef = useRef<HTMLDivElement>(null);
  const containerSize = useSize(containerRef);
  const heightRef = useRef<number>(0);

  const streamTextFunctionRef = useRef<StreamTextFunction>(null);

  function onStreamingContentChanged(value: string) {
    props.onStreamingContentChanged?.();
    heightRef.current = containerSize?.height ?? 0;
  }

  return (
    <div className={styles.container} ref={containerRef}>
      <div className={styles.contentContainer}>
        <div className={styles.leftCornersBox}>
          <div className={styles.leftTopCorners}></div>
          {props.showMask ? (
            <div className={styles.leftMessageMask}>
              <svg
                className={styles.cornerMark}
                width="24"
                height="20"
                viewBox="0 0 24 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.841127 18.1589C1.06709 17.9329 1.18008 17.8199 1.28567 17.7076C2.95642 15.9305 3.92006 13.6041 3.99525 11.1661C4 11.012 4 10.8522 4 10.5327V0H24V20H1.60375C1.44654 20 1.36794 20 1.32186 19.9957C0.520964 19.9214 0.131034 18.9801 0.644822 18.3612C0.674384 18.3256 0.729964 18.27 0.841127 18.1589Z"
                  fill="#020C26"
                  fillOpacity="0.05"
                />
              </svg>
            </div>
          ) : (
            <div className={styles.leftBottomCorners}></div>
          )}
        </div>
        <div className={styles.messageContainer}>
          {props.isError ? <span className={styles.error}>{"An error occurred. "}</span> : null}
          <StreamText
            ref={streamTextFunctionRef}
            className={styles.message}
            disabled={props.disabledStream}
            isStreamStopped={props.isStreamStopped}
            content={props.message}
            // onStreamingStateChanged={ setStreaming }
            onStreamingContentChanged={value => onStreamingContentChanged(value)}
            onStreamingContentStopped={value => {
              if (value) {
                props.onStreamingContentStopped?.({ type: "Assistant", value });
              } else {
                props.onStreamingContentStopped?.();
              }
            }}
          />
        </div>
        <div className={styles.rightCorners}></div>
      </div>
      {/* !streaming &&  */}
      {props.isLast && (
        <ChatHandlePane
          isStreaming={!props.isStreamStopped}
          onRegenerateClicked={() => props.onRegenerateClicked()}
          onStopGenerateClicked={() => {
            streamTextFunctionRef.current?.stop(true);
          }}
        />
      )}
    </div>
  );
}
